import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import "choerodon-ui/lib/configure/style";
import _configure from "choerodon-ui/lib/configure";
import "choerodon-ui/lib/get-config/style";
import _getConfig from "choerodon-ui/lib/get-config";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";

/**
 * 监听 theme 的 修改
 *
 */
import React from 'react';
import { connect } from 'dva';
import isEqual from 'lodash/isEqual';
import { getEnvConfig } from "../../utils/iocUtils";
var DefaultListenTheme = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(DefaultListenTheme, _React$PureComponent);
  var _super = _createSuper(DefaultListenTheme);
  function DefaultListenTheme(props) {
    var _this;
    _classCallCheck(this, DefaultListenTheme);
    _this = _super.call(this, props);
    _this.state = {};
    return _this;
  }
  _createClass(DefaultListenTheme, [{
    key: "setCurrentTheme",
    value: function setCurrentTheme() {
      var _this$props = this.props,
        userThemeConfig = _this$props.userThemeConfig,
        setTheme = _this$props.setTheme;
      var themeColor = userThemeConfig.themeColor,
        menuLayoutTheme = userThemeConfig.menuLayoutTheme,
        fieldLabelLayout = userThemeConfig.fieldLabelLayout,
        tableOperationLayout = userThemeConfig.tableOperationLayout;
      var finalLayout;
      var labelAlign;
      if (['float', 'vertical'].includes(fieldLabelLayout)) {
        finalLayout = fieldLabelLayout;
        labelAlign = 'left';
      } else if (fieldLabelLayout) {
        var _fieldLabelLayout$spl = fieldLabelLayout.split('-');
        var _fieldLabelLayout$spl2 = _slicedToArray(_fieldLabelLayout$spl, 2);
        finalLayout = _fieldLabelLayout$spl2[0];
        labelAlign = _fieldLabelLayout$spl2[1];
      }
      var inputData = {};
      if (finalLayout && labelAlign) {
        inputData.layout = finalLayout;
        inputData.labelAlign = labelAlign;
      }
      setTheme(menuLayoutTheme, undefined, {
        colors: {
          primary: themeColor
        },
        data: {
          input: inputData,
          table: {
            buttonsAlign: tableOperationLayout
          }
        }
      });
      if (menuLayoutTheme === 'nightingale') {
        this.oldTabsConfig = _getConfig('tabsInkBarStyle');
        _configure({
          tabsInkBarStyle: {
            width: 20
          }
        });
      } else {
        _configure({
          tabsInkBarStyle: _objectSpread({}, this.oldTabsConfig || {})
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props$entryList;
      var _getEnvConfig = getEnvConfig(),
        MULTIPLE_SKIN_ENABLE = _getEnvConfig.MULTIPLE_SKIN_ENABLE;
      var ued = false;
      try {
        ued = MULTIPLE_SKIN_ENABLE ? JSON.parse(MULTIPLE_SKIN_ENABLE) : false;
      } catch (e) {
        ued = false;
      }
      var themeChanged = !isEqual(prevProps.userThemeConfig, this.props.userThemeConfig);
      var uedFlag = ((_this$props$entryList = this.props.entryList.find(function (item) {
        return item.entryCode === 'HZERO.MULTIPLE_SKIN';
      })) === null || _this$props$entryList === void 0 ? void 0 : _this$props$entryList.enableFlag) || 1;
      if (themeChanged && ued && uedFlag) {
        this.setCurrentTheme();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return DefaultListenTheme;
}(React.PureComponent);
export default connect(function (_ref) {
  var global = _ref.global,
    _ref$user = _ref.user;
  _ref$user = _ref$user === void 0 ? {} : _ref$user;
  var _ref$user$currentUser = _ref$user.currentUser,
    currentUser = _ref$user$currentUser === void 0 ? {} : _ref$user$currentUser;
  return {
    userThemeConfig: currentUser.userThemeConfig || {},
    currentUser: currentUser,
    entryList: global.entryList || []
  };
})(DefaultListenTheme);